import { BaseModel } from "pages/Core/base.model";

export class VendorFormModel extends BaseModel {
    name!: string;
    mobile!: string;
    email!: string;
    gstNumber!: string;
    panNumber!: string;
    category!: any;
    paymentTerms!: string;
    isPreferredVendor!: boolean;
    creditDays!: number | string;
    rate!: number;

    static setVendorFromData(data: VendorFormModel): VendorFormModel {
        const model = new VendorFormModel();

        model.id = data.id ?? 0;
        model.name = data.name ?? '';
        model.mobile = data.mobile ?? '';
        model.email = data.email ?? '';
        model.gstNumber = data.gstNumber ?? '';
        model.panNumber = data.panNumber ?? '';
        model.category = data.category ?? '';
        model.paymentTerms = data.paymentTerms ?? 'Net 30 Days';
        model.isPreferredVendor = data.isPreferredVendor ?? false;
        if (data.creditDays !== null && data.creditDays !== undefined && data.creditDays !== '') {
            model.creditDays = Number(data.creditDays);
        }
        model.rate = data.rate ?? 0;

        return model;
    }
}
